export default __webpack_public_path__ + "static/media/menu-iot-icon.7bd20733.svg";